export const getAttribute = (person, type) =>
  person?.attributes?.find?.(({ attribute }) => attribute === type)?.value ??
  '';

export const getFullName = (person) =>
  [getAttribute(person, 'first_name'), getAttribute(person, 'last_name')]
    .filter((name) => name != null)
    .join(' ');
